import { gpHome } from '../../app';
import { dayjs } from '#gp/app-common/util/dayjs';

import { SimpleProject } from '../../controllers/boards-controller';
import { PlanListEmptyState } from '#gp/app-home/models/plan-list-empty-state';
import projectListTemplate from './project-list.html';

class ProjectListController {
    static $inject = ['$scope'];

    public onCreate?: () => void;
    public onClearSearch?: () => void;
    public items: SimpleProject[] = [];
    public isLoading: boolean = false;
    public emptyState: PlanListEmptyState | null = null;
    public currentUserEmail: string | null = null;
    constructor(
        private $scope: ng.IScope,
    ) {
    }
}

gpHome.directive("gpProjectList", [
    '$timeout',
    function (
        $timeout: ng.ITimeoutService,
    ): ng.IDirective {
        return ({
            restrict: 'E',
            scope: {
                items: '=',
                isLoading: '<',
                emptyState: '<?',
                currentUserEmail: '<?',
                onCreate: '&?',
                onClearSearch: '&?',
            },
            link: ($scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {

                let elem = element.get(0) as HTMLElement;
                let ctrl: ProjectListController = controller;

                let lastKnownScrollY = 0;
                let onlyAllowScrollEventsAfter: dayjs.Dayjs | null = null;

                {
                    // Options for the observer (which mutations to observe).
                    // subtree matters: the card grid nests the repeated items
                    // inside wrapper divs, so direct-children observation
                    // would never fire.
                    const config = { attributes: true, childList: true, subtree: true };

                    // Callback function to execute when mutations are observed
                    const callback = function (mutationsList: any, observer: any) {
                        let now = dayjs();
                        // Use traditional 'for loops' for IE 11
                        for (const mutation of mutationsList) {
                            if (mutation.type === 'childList') {
                                onlyAllowScrollEventsAfter = dayjs().add(500, 'ms');
                            }
                        }
                    };

                    // Create an observer instance linked to the callback function
                    const observer = new MutationObserver(callback);

                    // Start observing the target node for configured mutations
                    observer.observe(elem, config);
                }

                elem.addEventListener('scroll', (ev) => {
                    let now = dayjs();
                    if (onlyAllowScrollEventsAfter && now.isBefore(onlyAllowScrollEventsAfter)) {
                        elem.scrollTo(0, lastKnownScrollY);
                    } else {
                        lastKnownScrollY = elem.scrollTop;
                    }
                });

            },
            controller: ProjectListController,
            controllerAs: '$ctrl',
            bindToController: true,
            template: projectListTemplate,
        });
    }]);
